import actions from '@/store/createTemplates/actions';

const createTemplateModule = {
  state: () => ({
    frames: [],
    materials: [],
    frameDetails: {},
    frameOptions: [],
    frameOptionDisplays: [],
    sizes: [],
    colors: [],
    collagePreviewImage: [],
    isLoadImages: false,
    isLoading: false,
    error: null,
    hintMedia: [],
    customSizeSettings: null,
  }),
  getters: {
    getTemplateFrames(state) {
      return (id) => state.frames.filter((item) => item.frameMaterialId === id
        && !item.isDeleted
        && !item.productCollectionId);
    },
    frameOptions(state) {
      const data = state.frameOptions.reduce((acc, item) => {
        if (acc[item.frameSize.id]) {
          return {
            ...acc,
            [item.frameSize.id]: {
              ...acc[item.frameSize.id],
              options: [...acc[item.frameSize.id].options, item],
            },
          };
        }
        return {
          ...acc,
          [item.frameSize.id]: {
            name: item.frameSize.name,
            key: item.frameSize.name,
            options: [item],
          },
        };
      }, {});
      return Object.values(data).map((item) => item);
    },
    frameSizes(state) {
      return state.sizes.map((item) => ({ value: item.id, label: item.name }));
    },
    frameColors(state) {
      return (id) => {
        const colors = state.colors[id] || [];
        return colors.map((item) => (
          {
            value: item.id,
            label: item.name,
            colorHex: item.colorHex,
          }
        ));
      };
    },
  },
  mutations: {
    GET_OPTIONS_START(state) {
      state.isLoading = true;
      state.error = null;
    },
    GET_OPTIONS_SUCCESS(state, data) {
      state.materials = data;
      state.isLoading = false;
      state.error = null;
    },
    GET_OPTIONS_FAILURE(state, data) {
      state.isLoading = false;
      state.error = data;
    },
    GET_COLLECTION_FRAMES_SUCCESS(state, data) {
      state.frames = data;
      state.isLoading = false;
      state.error = null;
    },
    GET_FRAME_DETAILS_SUCCESS(state, data) {
      state.frameDetails = {
        ...data,
        customInfo: data.customInfo ? JSON.parse(data.customInfo) : {},
      };
    },
    GET_FRAME_OPTIONS_SUCCESS(state, data) {
      state.frameOptions = data;
    },
    GET_FRAME_SIZES_SUCCESS(state, data) {
      state.sizes = data;
    },
    GET_FRAME_COLORS_SUCCESS(state, data) {
      state.colors = data;
    },
    GET_OPTION_DISPLAYS_SUCCESS(state, data) {
      state.frameOptionDisplays = data?.sort((itemA, itemB) => {
        if (itemA.position < itemB.position) { return -1; }
        if (itemA.position > itemB.position) { return 1; }
        return 0;
      });
    },
    GET_COLLAGE_PREVIEW_IMAGES_START(state) {
      state.collagePreviewImage = [];
      state.isLoadImages = true;
    },
    GET_COLLAGE_PREVIEW_IMAGES_SUCCESS(state, data) {
      state.collagePreviewImage = data;
      state.isLoadImages = false;
    },
    GET_COLLAGE_PREVIEW_IMAGES_FAILURE(state) {
      state.collagePreviewImage = [];
      state.isLoadImages = false;
    },
    GET_HINT_MEDIA_SUCCESS(state, data) {
      state.hintMedia = data;
    },
    GET_CUSTOM_SIZE_SETTINGS_SUCCESS(state, data) {
      state.customSizeSettings = data;
    },
  },
  actions,
  namespaced: true,
};

export default createTemplateModule;
